export default __webpack_public_path__ + "static/media/2_0072.2e166d23.webp";